var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#35A1EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 36.5V41M29 32V41M35 27.5V41M41 23V41M20 48.5H44C45.1935 48.5 46.3381 48.0259 47.182 47.182C48.0259 46.3381 48.5 45.1935 48.5 44V20C48.5 18.8065 48.0259 17.6619 47.182 16.818C46.3381 15.9741 45.1935 15.5 44 15.5H20C18.8065 15.5 17.6619 15.9741 16.818 16.818C15.9741 17.6619 15.5 18.8065 15.5 20V44C15.5 45.1935 15.9741 46.3381 16.818 47.182C17.6619 48.0259 18.8065 48.5 20 48.5Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/Data.e3ddc696a70461a3c65e40ab7d33bcaf.svg";
export { ForwardRef as ReactComponent };